// extracted by mini-css-extract-plugin
export default {"productDescription":"l_-z","featuredDescription":"m_-z","description":"n_-z","more":"o_-z","descriptionSku":"p_-z"};